/**
 * slideTo.js
 *
 * @Author: jruif
 * @Date: 2018/6/1 下午3:38
 */

import './rAF.js';
import tweenFunction from 'tween-functions';

/* *
*
示例：
slideTo({
    beginValue: current.ref.scrollTop,
    endValue: checked.offsetTop - current.ref.offsetTop - current.ref.offsetHeight * 0.3,
    stepCallback: value => {
        current.ref.scrollTop = value;
    },
});
* */
const slideTo = ({
  beginValue, // 起点
  endValue, // 终点
  time = 800, // 执行动画时长
  tweenName = 'easeOutQuint', // 动画函数
  stepCallback, // 每一次位移后的回调
  endCallback = () => {}, // 执行完所有后的回调
}) => {
  const { requestAnimationFrame, cancelAnimationFrame } = window;
  const totalDuration = (time * 60) / 1000; // 1s 60fps
  let currentTime = 1;
  let handleRAF;
  function run() {
    const tweenValue = tweenFunction[tweenName](currentTime++, beginValue, endValue, totalDuration);
    if (handleRAF) {
      cancelAnimationFrame(handleRAF);
    }
    // scrollTo(pageXOffset, tweenValue);
    stepCallback && stepCallback(tweenValue);
    if (Math.floor((tweenValue - endValue) * 10e5) !== 0) {
      handleRAF = requestAnimationFrame(run);
    } else {
      setTimeout(endCallback);
    }
  }
  run();
};

export default slideTo;



// WEBPACK FOOTER //
// ./src/util/slideTo.js